module.exports = __webpack_public_path__ + "static/img/style2.18228be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/style2.png
// module id = VflQ
// module chunks = 4